import styled from 'styled-components'
import { Link } from 'react-router-dom'


export const Nav = styled.nav`
    background: #bccea5;
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
`;

export const LeftContainer = styled.div`
    display: -webkit-inline-box;
    justify-content: flex-start;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding-left: 50px;
`;

export const RightContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 80px;
    width: 100%;
    padding-right: 50px;
`;

export const NavLogo = styled(Link)`
    justify-self: flex-start;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const NavImg = styled.img`
    width: 75%;
    margin-right: 0.5rem;
    transition: 0.2s ease-in-out;

    &:hover {
        transform: scale(1.02);
        transition: 0.2s ease-in-out;
    }
`;

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 1010px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #f9f9f9;
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;

    @media screen and (max-width: 1010px) {
        display: none;
    }
`;

export const NavItem = styled.li`
    height: 80px;

    &:hover {
        transform: scale(1.02);
        border-bottom: 3px solid #ad625c;
    }
`;

export const NavLinks = styled(Link)`
    color: #f9f9f9;
    font-weight: 500;
    display: flex;
    align-items: flex-end;
    text-decoration: none;
    padding: 0 1rem;
    height: 80%;
    cursor: pointer;
`;

export const NavBtn = styled.nav`
    display: flex;
    align-items: flex-end;
    height: 80%;
    
    @media screen and (max-width: 1010px) {
        display: none;
    }
`;

export const NavBtnLink = styled(Link)`
    border-radius: 4px;
    background: #606c38;
    white-space: nowrap;
    padding: 10px 22px;
    color: #f9f9f9;
    font-size: 16px;
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    margin-left: 10px;
    
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #ad625c;
        transform: scale(1.02);
    }
`;